import React from 'react';
import { map } from 'lodash';
import { connect } from 'react-redux';

import {
    DISPLAY_STEP,
    STATE_PENDING,
    STATE_VALID,
    STATE_INVALID
} from '../../../../constants/payment';
import {
    PURCHASE_TYPE_GIVEAWAY_BONUS,
    PURCHASE_TYPE_REMAINING_POOL
} from '../../../../constants/purchase';
import { STATIC_ROOT } from '../../../../constants';
import { MOMENTJS_DATE_FORMAT_STANDARD } from '../../../../constants/moment';

import { fetchAccountPurchasesIfNeeded } from '../../../../services/account/cashback/actions';

import { toDate } from '../../../../utils/dateUtils';
import { formatAmountCurrency } from '../../../../utils/index';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import SvgComponent from '../../../SvgComponent';
import { LoadingComponent } from '../../../loading/LoadingComponent';
import CashbackHistoryLegendComponent from './CashbackHistoryLegendComponent';

const renderPurchaseState = (icon, text, width, height) => (
    <React.Fragment>
        <span>{text}</span>
        <span>
            <SvgComponent
                src={`${STATIC_ROOT}/icon/picto-${icon}.svg`}
                width={width}
                height={height}
                aria-hidden="true"
                focusable="false"
            />
        </span>
    </React.Fragment>
);

class CashbackHistoryComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { index: DISPLAY_STEP };
    }

    componentDidMount() {
        this.props.fetchAccountPurchasesIfNeeded();
        this.scrollTop();
    }

    scrollTop = () => {
        if (document.getElementById('purchases')) {
            document.getElementById('purchases').scrollIntoView({ behavior: 'smooth' });
        }
    };

    renderConditionnalOnPurchaseState(purchaseState, paymentDate) {
        if (!purchaseState) return null;

        const i18n = this.props.i18n;

        if (purchaseState === STATE_VALID && paymentDate > 0) {
            return renderPurchaseState('check', i18n.PAID, 20, 20);
        } else if (purchaseState === STATE_VALID) {
            return renderPurchaseState('validation', i18n.VALID, 20, 20);
        } else if (purchaseState === STATE_PENDING) {
            return renderPurchaseState('pending', i18n.WAITING, 20, 20);
        } else if (purchaseState === STATE_INVALID) {
            return renderPurchaseState('invalide', i18n.INVALID, 20, 20);
        }
    }

    renderSeeMoreButton(filtered) {
        const { i18n } = this.props;
        const { index } = this.state;

        if (filtered.length >= DISPLAY_STEP && index < filtered.length) {
            return (
                <div className="purchase-button">
                    <button
                        type="button"
                        id="more-purchase-button"
                        className="see-more-button"
                        title={i18n.SEE_MORE_OPERATION}
                        onClick={this.handleSeeMoreClick}>
                        <span className="plus" aria-hidden="true">
                            +
                        </span>
                        <span className="text">{i18n.SEE_MORE_OPERATION}</span>
                    </button>
                </div>
            );
        }
    }

    handleSeeMoreClick = () => {
        this.setState({
            index: this.state.index + DISPLAY_STEP
        });
    };

    getPartnerName = purchase => {
        if (purchase.type === PURCHASE_TYPE_GIVEAWAY_BONUS) {
            return purchase.label;
        }
        return purchase.partnerName;
    };

    render() {
        const { data, fetching, i18n } = this.props;
        const { index } = this.state;

        const safeData = Array.isArray(data) ? data : [];
        const filtered = safeData.filter(p => p.type !== PURCHASE_TYPE_REMAINING_POOL);
        const visiblePurchases = filtered.slice(0, index);

        return (
            <div id="purchases">
                <h3>{i18n.PURCHASE_HISTORY}</h3>
                <div className="information-div" role="note">
                    <span aria-hidden="true">
                        <SvgComponent
                            src={`${STATIC_ROOT}/information.svg`}
                            width="20"
                            height="20"
                            aria-hidden="true"
                            focusable="false"
                        />
                    </span>
                    <span>{convertHtmlToReactDomWithParams(i18n.GAIN_CASHBACK_HISTORIC)}</span>
                </div>

                {!fetching && visiblePurchases.length > 0 && (
                    <table className="purchases-table" aria-label={i18n.TABLE_LABEL}>
                        <thead className="sr-only">
                            <tr>
                                <th scope="col">{i18n.COLUMN_DATE}</th>
                                <th scope="col">{i18n.COLUMN_PARTNER}</th>
                                <th scope="col">{i18n.COLUMN_AMOUNT}</th>
                                <th scope="col">{i18n.COLUMN_STATE}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {map(visiblePurchases, (purchase, i) => (
                                <tr className="container-purchase" key={i}>
                                    <td>
                                        {toDate(
                                            purchase.purchaseDate,
                                            MOMENTJS_DATE_FORMAT_STANDARD
                                        )}
                                    </td>
                                    <td>{this.getPartnerName(purchase)}</td>
                                    <td>{formatAmountCurrency(purchase.gain)}</td>
                                    <td>
                                        {this.renderConditionnalOnPurchaseState(
                                            purchase.state,
                                            purchase.paymentDate
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}

                {(fetching || safeData.length === 0) && (
                    <div
                        className={`container-purchase empty ${fetching ? 'fetching' : ''}`}
                        role="status"
                        aria-live="polite">
                        {fetching ? <LoadingComponent /> : i18n.NO_PURCHASE}
                    </div>
                )}

                {this.renderSeeMoreButton(filtered)}

                <CashbackHistoryLegendComponent />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT,
        fetching: state.account.mycashback.fetching,
        data: state.account.mycashback.purchases || []
    };
}

const mapDispatchToProps = {
    fetchAccountPurchasesIfNeeded
};

export default connect(mapStateToProps, mapDispatchToProps)(CashbackHistoryComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/CashbackHistoryComponent.js